import type { GetDisplayNameForUsersProps } from '../types.ts';

export const getDisplayNameForUsers = ({ users }: GetDisplayNameForUsersProps) => {
  const displayNames = new Set(users.map((user) => user.displayName));
  const iterator = displayNames.values();
  const displayName = iterator.next().value ?? '';
  const somebodyElse = iterator.next().value ?? '';
  const displayNamesCount = displayNames.size;

  return { displayNamesCount, displayName, somebodyElse };
};
